<div class="card card-custom custom-table gutter-b">

    <!--Header-->
    <div class="card-header border-0 flex-column">
        <div class="d-flex justify-content-between flex-wrap">
            <!--Card Title-->
            <div class="card-title">
                <h1 class="card-label m-0" translate="PROCEDURES.LIST"></h1>
            </div>
            <!--Actions-->
            <div class="card-toolbar">
                <button type="button" class="btn-default btn-green flex-row-reverse add-button"
                        routerLink="/procedures/add"
                        *ngIf="userRole | roleChecker : ['ROLE_super_admin','ROLE_admin','ROLE_ProceduresFull']">
                    <span translate="GENERAL.ADD"></span>
                    <span class="fas fa-plus mr-3"></span>
                </button>
            </div>
        </div>

        <!--Table Data List Filter-->
        <p class="toggle-filters mt-5 mb-0" role="button" (click)="toggleFilters()">
            <span *ngIf="hideFilters" class="fas fa-angle-down mr-1"></span>
            <span *ngIf="!hideFilters" class="fas fa-angle-up mr-1"></span>
            {{ hideFilters ? 'Show Filters' : 'Hide Filters' }}
        </p>
    </div>
    <div class="card-body">

        <!--Table Data Filters-->
        <div id="filtersRow" class="filter-row row">
            <div class="table-selection col-12 col-sm-5 col-md-3 col-xl-2">
                <label>{{"CONTACTS.STATUS" | translate}}</label>
                <select class="form-control form-control-lg form-layout custom-select" name="search-type"
                        id="procedureStatusSelect">
                    <option value=""> {{"ECOMMERCE.COMMON.ALL" | translate | titlecase}} </option>
                    <option [value]="'Draft'">{{"GENERAL.STATUS_DRAFT" | translate | titlecase }}</option>
                    <option [value]="'Published'">{{"GENERAL.STATUS_PUBLISHED" | translate | titlecase}}</option>
                    <option [value]="'Archived'">{{"GENERAL.STATUS_INACTIVE" | translate | titlecase}}</option>
                </select>
            </div>

            <div class="table-search
                        col-12 col-sm-5 col-md-3 col-xl-3
                        ml-sm-auto">
                <label>Search</label>
                <input id="tableSearchBox">
                <span class="fas fa-search"></span>
            </div>
        </div>

        <!--Feedback Filters-->
        <app-form-message *ngIf="formSent" [success]="formResponse" [customErrorMessage]="errorMsg"
                          [customSuccessMessage]="successMsg"></app-form-message>

        <div class="table-loader">
            <!--spinner while fetching new data-->
            <div id="mySpinner" class="spinner-background">
                <div class="spinner-border text-primary"></div>
            </div>

            <table id="myTable" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"
                   class="table nowrap compact hover order-column">
                <thead>
                <tr>
                    <th>Nr.</th>
                    <th translate="PROCEDURES.TITLE"></th>
                    <th translate="PROCEDURES.CATEGORIES"></th>
                    <th translate="PROCEDURES.DATE"></th>
                    <th translate="PROCEDURES.STATUS"></th>
                    <th translate="PROCEDURES.ACTIONS"></th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let procedure of procedures; let i = index">
                    <!--Nr-->
                    <td>{{i + 1}}</td>
                    <!--Title-->
                    <td class="cell-hover" routerLink="/procedures/{{procedure.id}}">
                        {{procedure.title}}
                    </td>
                    <!--Categories-->
                    <td>{{procedure.categories}}</td>
                    <!--Date-->
                    <td>{{ procedure.date }}</td>
                    <!--Status-->
                    <td>
                        <span class="label label-lg label-inline" [ngClass]="
                        {'label-light-primary': procedure.status === 'Draft',
                        'label-light-danger': procedure.status === 'Archived',
                        'label-light-success': procedure.status === 'Published'}"
                        >
                        <span *ngIf="procedure.status === 'Draft'">{{"GENERAL.STATUS_DRAFT" | translate | titlecase }}</span>
                        <span *ngIf="procedure.status === 'Published'">{{"GENERAL.STATUS_PUBLISHED" | translate | titlecase }}</span>
                        <span *ngIf="procedure.status === 'Archived'">{{"GENERAL.STATUS_INACTIVE" | translate | titlecase}}</span>
                    </span>
                    </td>
                    <!--Actions-->
                    <td>
                        <div class='d-flex justify-content-end'>
                            <button type="button" class="btn-list btn-main"
                                    [ngClass]="(userRole | roleChecker : ['ROLE_ProceduresView', 'ROLE_demo_user']) ? '' : 'mr-2'"
                                    placement="bottom" ngbTooltip="View procedure"
                                    routerLink="/procedures/{{procedure.id}}"
                                    *ngIf="userRole | roleChecker : ['ROLE_super_admin','ROLE_admin','ROLE_ProceduresFull','ROLE_ProceduresView', 'ROLE_demo_user']">
                                <span class="far fa-eye"></span>
                            </button>

                            <button type="button" class="btn-list btn-main mr-2"
                                    placement="bottom" ngbTooltip="Edit Procedure"
                                    routerLink="/procedures/edit/{{procedure.id}}"
                                    *ngIf="userRole | roleChecker : ['ROLE_super_admin','ROLE_admin','ROLE_ProceduresFull']">
                                <span class="fas fa-pen"></span>
                            </button>

                            <button type="button" class="btn-list btn-main"
                                    placement="bottom" ngbTooltip="Change Procedure Status"
                                    (click)="changeStatusModal(statusChange)"
                                    *ngIf="userRole | roleChecker : ['ROLE_super_admin','ROLE_admin','ROLE_ProceduresFull']">
                                <span class="fas fa-toggle-on"></span>
                            </button>
                        </div>
                    </td>
                    <td>
                        <!--empty table data-->
                    </td>
                    <!--Modal - Change status-->
                    <ng-template #statusChange let-c="close" let-d="dismiss">
                        <div class="modal-header">
                            <h4 class="modal-title text-white" translate="CONTACTS.CHANGE_STATUS"></h4>
                        </div>
                        <div class="modal-body">
                            <select name="status_{{procedure.id}}" class="form-control"
                                    #statusController required>
                                <option [value]="'Draft'"
                                        [selected]="procedure.status === 'Draft'">{{"GENERAL.STATUS_DRAFT" | translate  | titlecase}}</option>
                                <option [value]="'Published'"
                                        [selected]="procedure.status === 'Published'">{{"GENERAL.STATUS_PUBLISHED" | translate | titlecase }}</option>
                                <option [value]="'Archived'"
                                        [selected]="procedure.status === 'Archived'">{{"GENERAL.STATUS_INACTIVE" | translate  | titlecase}}</option>
                            </select>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn-default btn-red" (click)="c()">Close</button>
                            <button type="button" class="btn-default btn-main"
                                    (click)="changeStatus(procedure.id, statusController.value)">{{"GENERAL.CHANGE_STATUS" | translate}}
                            </button>
                        </div>
                    </ng-template>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
